import React, { lazy } from "react";
import ReactDOM from "react-dom/client";
import "./Stylesheets/App.css";
import "./DisableLogs";
import { BrowserRouter } from "react-router-dom";
import LandingJazzCash from "./JazzCash";
const App = lazy(() => import("./App"));

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    {window.location.pathname.includes("/jc") ||
    (window.location.pathname.includes("/landing") &&
      !localStorage.getItem("msisdn")) ? (
      <LandingJazzCash />
    ) : (
      <App />
    )}
  </BrowserRouter>,
);
